import { client } from './client';

export const servicesMonitorApi = {
  getStatus: () => client.get('get_services_status'),
  restart: (name) => client.post('restart_monitored_service', { name }),
  testTicketPipeline: (text) => client.post('test_service_ticket_pipeline', { text }),
  testLLM: (prompt) => client.post('test_service_llm', { prompt }),
  testLLMWithKnowledgeBase: (prompt) => client.post('test_service_llm_with_kb', { prompt }),
  testSummarizer: (text) => client.post('test_service_summarizer', { text }),
};
